<header class="header" [class.expanded]="!isCollapsed">

  <div class="header-left" [class.marginLeft]="isCollapsed" [class.marginLeftLittle]="!isCollapsed">
    <div class="welcome-message d-flex align-items-center gap-2">
      <span class="dynamic-emoji">{{ currentEmoji }}</span>

      <p class="mb-0">
        <span class="fs-16">{{ messagePrefix }}</span>
        <span class="fw-500 gradient-text fs-16">
          {{ userName }}
        </span>
        <span class="fs-12">{{ messageSuffix }}</span>
      </p>
    </div>
  </div>

  <div class="header-right">

    <div class="header-section">

      <span matTooltip="Dashboard" matTooltipPosition="below" [matTooltipClass]="'dynamic-tooltip'"
        class="position-relative icon hover-fill" (click)="setActiveTab('overview')" (mouseenter)="showDropdown=false"
        [class.applyBgActive]="activeTab == 'overview'"
        *ngIf="userAccess != enumRole.ADMIN_INSURER &&  userAccess != enumRole.ADMIN_PROVIDER &&  role != enumRole.PROVIDER &&  role != enumRole.SUPER_ADMIN
        && userAccess != enumRole.ADMIN_DISTRIBUTOR">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 15 15">
          <path fill="#0075C9" fill-rule="evenodd"
            d="M2.8 1h-.05c-.229 0-.426 0-.6.041A1.5 1.5 0 0 0 1.04 2.15c-.04.174-.04.37-.04.6v2.5c0 .229 0 .426.041.6A1.5 1.5 0 0 0 2.15 6.96c.174.04.37.04.6.04h2.5c.229 0 .426 0 .6-.041A1.5 1.5 0 0 0 6.96 5.85c.04-.174.04-.37.04-.6v-2.5c0-.229 0-.426-.041-.6A1.5 1.5 0 0 0 5.85 1.04C5.676 1 5.48 1 5.25 1zm-.417 1.014c.043-.01.11-.014.417-.014h2.4c.308 0 .374.003.417.014a.5.5 0 0 1 .37.37c.01.042.013.108.013.416v2.4c0 .308-.003.374-.014.417a.5.5 0 0 1-.37.37C5.575 5.996 5.509 6 5.2 6H2.8c-.308 0-.374-.003-.417-.014a.5.5 0 0 1-.37-.37C2.004 5.575 2 5.509 2 5.2V2.8c0-.308.003-.374.014-.417a.5.5 0 0 1 .37-.37M9.8 1h-.05c-.229 0-.426 0-.6.041A1.5 1.5 0 0 0 8.04 2.15c-.04.174-.04.37-.04.6v2.5c0 .229 0 .426.041.6A1.5 1.5 0 0 0 9.15 6.96c.174.04.37.04.6.04h2.5c.229 0 .426 0 .6-.041a1.5 1.5 0 0 0 1.11-1.109c.04-.174.04-.37.04-.6v-2.5c0-.229 0-.426-.041-.6a1.5 1.5 0 0 0-1.109-1.11c-.174-.04-.37-.04-.6-.04zm-.417 1.014c.043-.01.11-.014.417-.014h2.4c.308 0 .374.003.417.014a.5.5 0 0 1 .37.37c.01.042.013.108.013.416v2.4c0 .308-.004.374-.014.417a.5.5 0 0 1-.37.37c-.042.01-.108.013-.416.013H9.8c-.308 0-.374-.003-.417-.014a.5.5 0 0 1-.37-.37C9.004 5.575 9 5.509 9 5.2V2.8c0-.308.003-.374.014-.417a.5.5 0 0 1 .37-.37M2.75 8h2.5c.229 0 .426 0 .6.041A1.5 1.5 0 0 1 6.96 9.15c.04.174.04.37.04.6v2.5c0 .229 0 .426-.041.6a1.5 1.5 0 0 1-1.109 1.11c-.174.04-.37.04-.6.04h-2.5c-.229 0-.426 0-.6-.041a1.5 1.5 0 0 1-1.11-1.109c-.04-.174-.04-.37-.04-.6v-2.5c0-.229 0-.426.041-.6A1.5 1.5 0 0 1 2.15 8.04c.174-.04.37-.04.6-.04m.05 1c-.308 0-.374.003-.417.014a.5.5 0 0 0-.37.37C2.004 9.425 2 9.491 2 9.8v2.4c0 .308.003.374.014.417a.5.5 0 0 0 .37.37c.042.01.108.013.416.013h2.4c.308 0 .374-.004.417-.014a.5.5 0 0 0 .37-.37c.01-.042.013-.108.013-.416V9.8c0-.308-.003-.374-.014-.417a.5.5 0 0 0-.37-.37C5.575 9.004 5.509 9 5.2 9zm7-1h-.05c-.229 0-.426 0-.6.041A1.5 1.5 0 0 0 8.04 9.15c-.04.174-.04.37-.04.6v2.5c0 .229 0 .426.041.6a1.5 1.5 0 0 0 1.109 1.11c.174.041.371.041.6.041h2.5c.229 0 .426 0 .6-.041a1.5 1.5 0 0 0 1.109-1.109c.041-.174.041-.371.041-.6v-2.5c0-.229 0-.426-.041-.6A1.5 1.5 0 0 0 12.85 8.04c-.174-.04-.37-.04-.6-.04zm-.417 1.014c.043-.01.11-.014.417-.014h2.4c.308 0 .374.003.417.014a.5.5 0 0 1 .37.37c.01.042.013.108.013.416v2.4c0 .308-.004.374-.014.417a.5.5 0 0 1-.37.37c-.042.01-.108.013-.416.013H9.8c-.308 0-.374-.004-.417-.014a.5.5 0 0 1-.37-.37C9.004 12.575 9 12.509 9 12.2V9.8c0-.308.003-.374.014-.417a.5.5 0 0 1 .37-.37"
            clip-rule="evenodd" />
        </svg>
      </span> &nbsp;&nbsp;

      <!-- <span matTooltip="Config" matTooltipPosition="below" class="position-relative icon hover-fill"
        (click)="setActiveTab('config')" (mouseenter)="showDropdown=false"
        [class.applyBgActive]="activeTab == 'config'" *ngIf="userAccess == enumRole.ADMIN_INSURER || userAccess == enumRole.ADMIN_PROVIDER">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="m19.59 15.5l-1.82-1.3c.3-1.08.32-2.25 0-3.42l1.82-1.28L18.14 7l-2.03.92c-.79-.8-1.79-1.42-2.96-1.71L12.95 4h-2.9l-.2 2.21c-1.17.29-2.17.91-2.96 1.71L4.86 7L3.41 9.5l1.82 1.28c-.32 1.17-.3 2.34 0 3.42l-1.82 1.3L4.86 18l2.03-.93c.79.79 1.79 1.39 2.96 1.7l.2 2.23h2.9l.2-2.23c1.17-.31 2.17-.91 2.96-1.7l2.03.93zM13.5 3c.27 0 .5.2.5.46l.18 2.04c.76.28 1.44.69 2.05 1.18l1.85-.87c.23-.12.52-.04.66.19l2 3.5c.14.21.06.5-.16.65l-1.67 1.17c.13.8.12 1.59 0 2.36l1.67 1.17c.22.15.3.44.16.65l-2 3.5c-.14.21-.43.29-.66.17l-1.85-.86c-.61.49-1.29.89-2.05 1.19l-.18 2c0 .29-.23.5-.5.5h-4a.5.5 0 0 1-.5-.5l-.18-2c-.76-.3-1.44-.7-2.05-1.19l-1.85.86c-.23.12-.52.04-.66-.17l-2-3.5c-.14-.21-.06-.5.16-.65l1.67-1.17c-.12-.77-.13-1.56 0-2.36l-1.67-1.17c-.22-.15-.3-.44-.16-.65l2-3.5c.14-.23.43-.31.66-.19l1.85.87c.61-.49 1.29-.9 2.05-1.18L9 3.46c0-.26.23-.46.5-.46zm-2 6a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5A3.5 3.5 0 0 1 8 12.5A3.5 3.5 0 0 1 11.5 9m0 1A2.5 2.5 0 0 0 9 12.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5"
            stroke-width="0.1" stroke="currentColor" />
        </svg>
      </span>&nbsp;&nbsp; -->

      <span matTooltip="Applicants" matTooltipPosition="below" class="position-relative icon hover-fill"
        (click)="setActiveTab('members')" (mouseenter)="showDropdown=false"
        [class.applyBgActive]="activeTab == 'members'" *ngIf="(role == enumRole.INSURER && (userAccess != enumRole.ADMIN_INSURER &&  userAccess != enumRole.ADMIN_PROVIDER)) ||
        (role == enumRole.DISTRIBUTOR && userAccess != enumRole.ADMIN_DISTRIBUTOR)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 15 15">
          <path fill="#0075C9"
            d="M10.5 14.49v.5h.5v-.5zm-10 0H0v.5h.5zm14 .01v.5h.5v-.5zM8 3.498a2.5 2.5 0 0 1-2.5 2.498v1C7.433 6.996 9 5.43 9 3.498zM5.5 5.996A2.5 2.5 0 0 1 3 3.498H2a3.5 3.5 0 0 0 3.5 3.498zM3 3.498A2.5 2.5 0 0 1 5.5 1V0A3.5 3.5 0 0 0 2 3.498zM5.5 1A2.5 2.5 0 0 1 8 3.498h1A3.5 3.5 0 0 0 5.5 0zm5 12.99H.5v1h10zm-9.5.5v-1.996H0v1.997zm2.5-4.496h4v-1h-4zm6.5 2.5v1.997h1v-1.997zm-2.5-2.5a2.5 2.5 0 0 1 2.5 2.5h1a3.5 3.5 0 0 0-3.5-3.5zm-6.5 2.5a2.5 2.5 0 0 1 2.5-2.5v-1a3.5 3.5 0 0 0-3.5 3.5zM14 13v1.5h1V13zm.5 1H12v1h2.5zM12 11a2 2 0 0 1 2 2h1a3 3 0 0 0-3-3zm-.5-3A1.5 1.5 0 0 1 10 6.5H9A2.5 2.5 0 0 0 11.5 9zM13 6.5A1.5 1.5 0 0 1 11.5 8v1A2.5 2.5 0 0 0 14 6.5zM11.5 5A1.5 1.5 0 0 1 13 6.5h1A2.5 2.5 0 0 0 11.5 4zm0-1A2.5 2.5 0 0 0 9 6.5h1A1.5 1.5 0 0 1 11.5 5z" />
        </svg>
      </span>
    </div>

    <!-- Notification Bell with Count -->
    <div class="notification-wrapper" (click)="toggleNotificationDropdown()" (mouseenter)="showDropdown=false"
      *ngIf="userAccess != enumRole.ADMIN_INSURER && userAccess != enumRole.ADMIN_PROVIDER && role != enumRole.SUPER_ADMIN
      && userAccess != enumRole.ADMIN_DISTRIBUTOR">

      <span matTooltip="Notifications" matTooltipPosition="below" class="position-relative icon iconNotification">
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="25" viewBox="0 0 24 24">
          <g fill="none" stroke-width="1.2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.479 5.749A4.5 4.5 0 0 1 16.5 10v3.7l2.073 1.935a.5.5 0 0 1-.341.865H5.769a.5.5 0 0 1-.342-.866L7.5 13.7V10a4.5 4.5 0 0 1 3.021-4.251a1.5 1.5 0 0 1 2.958 0" />
            <path d="M10.585 18.5a1.5 1.5 0 0 0 2.83 0z" />
          </g>
        </svg>
        <span class="notification-count">{{ notifications.length }}</span>
      </span>

      <!-- Notification Dropdown -->
      <div class="notification-dropdown message-list" *ngIf="showNotifications">

        <div class="d-flex flex-column gap-2">
          <div class="d-flex justify-content-around border-bottom">
            <p class="fs-14 mt-2 fw-500">Notifications</p>
          </div>

          <div class="d-flex justify-content-around">
            <p class="d-flex justify-content-center align-items-center navigations"
              (click)="selectAll();$event.stopPropagation()" [ngClass]="{'hightlight-background': allNotifications}">All
            </p>
            <p class="d-flex justify-content-center align-items-center navigations"
              (click)="selectUnread();$event.stopPropagation()"
              [ngClass]="{'hightlight-background': unreadNotifications}">Unread</p>
          </div>

          <div *ngIf="filteredNotifications.length === 0" class="p-3 text-center text-muted">
            No notifications to show.
          </div>

          <ng-container *ngIf="filteredNotifications.length > 0">

            <!-- Today -->
            <div *ngIf="todayNotifications.length > 0">
              <p class="fs-13 heading-background ml-2">Today</p>

              <div class="message-item d-flex align-items-center gap-2"
                *ngFor="let n of todayNotifications; trackBy: trackById" [ngClass]="{'unread': !n.read}"
                [@fadeAnimation] (click)="markAsRead(n);$event.stopPropagation()">
                <div class="patient-avatar position-relative">
                  <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <circle cx="22" cy="22" r="22" fill="#0075C9" />
                    <text x="50%" y="56%" text-anchor="middle" fill="#fffff" font-size="16" dy=".3em">
                      {{ n.name | initials : n.lastName : n.userId }}
                    </text>
                  </svg>
                  <span *ngIf="!n.read" class="msg-dot avatar-dot"></span>
                </div>
                <div class="flex-grow-1 d-flex align-items-center justify-content-between">
                  <div class="notification-content">
                    <div class="fs-13">{{ n.name ? n.name : n.userId}}</div>
                    <div class="fs-13 text-truncate" [ngClass]="{ 'text-muted': !n.unread }" [matTooltip]="n.message"
                      matTooltipPosition="above">
                      {{ n.message }}
                    </div>
                  </div>
                  <span class="fs-10 text-muted ms-2 flex-shrink-0" style="white-space:nowrap;">
                    {{ formatTodayDate(n.createdon) }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Older -->
            <div *ngIf="olderNotifications.length > 0">
              <p class="fs-13 heading-background ml-2">Older</p>

              <div class="message-item d-flex align-items-center gap-2" *ngFor="let n of olderNotifications"
                [ngClass]="{'unread': !n.read}" [@fadeAnimation] (click)="markAsRead(n);$event.stopPropagation()">

                <div class="patient-avatar position-relative">
                  <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <circle cx="22" cy="22" r="22" fill="#0075C9" />
                    <text x="50%" y="56%" text-anchor="middle" fill="#ffffff" font-size="16" dy=".3em">
                      {{ n.name | initials : n.lastName : n.userId }}
                    </text>
                  </svg>
                  <span *ngIf="!n.read" class="msg-dot avatar-dot"></span>
                </div>
                <div class="flex-grow-1 d-flex align-items-center justify-content-between">
                  <div class="notification-content">
                    <div class="fs-13">{{ n.name ? n.name : n.userId}}</div>
                    <div class="fs-13 text-truncate" [ngClass]="{ 'text-muted': !n.unread }" [matTooltip]="n.message"
                      matTooltipPosition="above">
                      {{ n.message }}
                    </div>
                  </div>
                  <span class="fs-10 text-muted ms-2 flex-shrink-0" style="white-space:nowrap;">
                    {{ formatTodayDate(n.createdon) }}
                  </span>
                </div>
              </div>
            </div>

          </ng-container>

        </div>
      </div>

    </div>

    <!-- Profile Dropdown Wrapper -->
    <div class="profile-wrapper" (mouseenter)="onProfileMouseEnter()"
      [class.applymarginTopProfile]="userAccess == enumRole.ADMIN_INSURER || userAccess == enumRole.ADMIN_PROVIDER">

      <span class="icon hover-fill">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="10 10 256 256">
          <path fill="#0075C9"
            d="M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8M72 96a56 56 0 1 1 56 56a56.06 56.06 0 0 1-56-56"
            stroke-width="1.5" />
        </svg>
      </span>

      <div class="dropdown-menu" *ngIf="showDropdown" [class.applyBg]="startLogoutAnimation">
        <div class="user-list-item" [class.animate-logout]="startLogoutAnimation"
          [class.applyBg]="startLogoutAnimation">
          <div class="user-avatar">
            {{ userName | initials}}
          </div>
          <div class="user-info">
            <div class="fs-14 fw-500">{{ userName }}</div>
            <div class="fs-12 gray-text">{{ userId }}</div>
          </div>
          <div class="d-flex flex-column align-items-center cursor-pointer" (click)="confirmLogout()">
            <span class="status-icon" style="transform: rotate(90deg);">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M6 6.5C4.159 8.148 3 10.334 3 13a9 9 0 1 0 18 0c0-2.666-1.159-4.852-3-6.5M12 2v9m0-9c-.7 0-2.008 1.994-2.5 2.5M12 2c.7 0 2.008 1.994 2.5 2.5" />
              </svg>
            </span>
            <span class="fs-8">Logout</span>
          </div>

        </div>
      </div>


    </div>

  </div>

</header>